/* ==========================================================================
   Floating Add to Cart bar - R5, 18 Aug 2026

   A SEPARATE button, not the real one relocated. That matters: it means both
   can be on screen at the same moment, so the handoff is continuous rather
   than the button vanishing and reappearing.

   Timing: the bar fades in as soon as the real button rises above the strip
   the bar occupies. So while the real button is still low on screen there is
   one button; as it travels up past the bar position the bar fades in below
   it; the real one dims so they don't compete; then it scrolls away and the
   bar carries on alone. Hides again over the review widget.

   Clicking the bar forwards the click to the real button, so all of the
   theme's own logic - validation, variant state, cart drawer - runs unchanged.
   ========================================================================== */
(function () {
  var MQ = window.matchMedia('(max-width: 749px)');
  var BAR_ZONE = 76; /* bar height + bottom gap + breathing room, in px */

  var realBtn, bar, clone, obsEnd, endEl, mo;
  var passed = false, atReviews = false, ticking = false, endTries = 0;

  function q(sel, root) {
    try { return (root || document).querySelector(sel); } catch (e) { return null; }
  }

  function findReal() {
    var info = q('.product__info-container') || document;
    return q('.product-form__buttons .product-form__submit', info);
  }

  function findEnd() {
    return q('.jdgm-rev-widg') || q('.jdgm-widget') ||
           q('#shopify-section-group-footer-group') || q('.footer') || null;
  }

  /* Copy only the theme's button classes. Deliberately drops
     product-form__submit so the theme's own fixed-position rule for that
     class cannot grab the clone as well. */
  function buttonClasses(el) {
    var out = [];
    (el.className || '').split(/\s+/).forEach(function (c) {
      if (c === 'button' || c.indexOf('button--') === 0) out.push(c);
    });
    if (out.indexOf('button') === -1) out.unshift('button');
    return out.join(' ');
  }

  function buildBar() {
    if (bar) return;
    bar = document.createElement('div');
    bar.className = 'rrc-atc-bar';
    bar.setAttribute('hidden', '');
    clone = document.createElement('button');
    clone.type = 'button';
    clone.className = buttonClasses(realBtn) + ' rrc-atc-clone';
    bar.appendChild(clone);
    document.body.appendChild(bar);

    clone.addEventListener('click', function (e) {
      e.preventDefault();
      if (realBtn && !realBtn.disabled) realBtn.click();
    });
  }

  /* Keep label and disabled state in step with the real button. */
  function mirror() {
    if (!realBtn || !clone) return;
    if (clone.innerHTML !== realBtn.innerHTML) clone.innerHTML = realBtn.innerHTML;
    var off = realBtn.disabled || realBtn.getAttribute('aria-disabled') === 'true';
    clone.disabled = !!off;
    if (off) clone.setAttribute('aria-disabled', 'true');
    else clone.removeAttribute('aria-disabled');
  }

  function watchReal() {
    if (mo) mo.disconnect();
    if (!('MutationObserver' in window) || !realBtn) return;
    mo = new MutationObserver(mirror);
    mo.observe(realBtn, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class']
    });
  }

  function render() {
    if (!bar) return;
    var show = MQ.matches && passed && !atReviews;
    if (show) {
      bar.removeAttribute('hidden');
      document.body.classList.add('rrc-atc-floating');
      if (realBtn) realBtn.classList.add('rrc-atc-dim');
    } else {
      bar.setAttribute('hidden', '');
      document.body.classList.remove('rrc-atc-floating');
      if (realBtn) realBtn.classList.remove('rrc-atc-dim');
    }
  }

  function measure() {
    ticking = false;
    if (!MQ.matches) { passed = false; render(); return; }

    /* Dawn replaces the buy buttons on variant change - re-resolve if so. */
    if (!realBtn || !realBtn.isConnected) {
      realBtn = findReal();
      if (!realBtn) { passed = false; render(); return; }
      if (clone) clone.className = buttonClasses(realBtn) + ' rrc-atc-clone';
      mirror();
      watchReal();
    }

    var r = realBtn.getBoundingClientRect();
    /* True once the real button has risen above the strip the bar sits in. */
    passed = r.bottom < (window.innerHeight - BAR_ZONE);
    render();
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(measure);
  }

  function bindEnd() {
    if (obsEnd) { obsEnd.disconnect(); obsEnd = null; }
    endEl = findEnd();
    if (!endEl) { if (endTries++ < 6) setTimeout(bindEnd, 800); return; }
    if (!('IntersectionObserver' in window)) return;
    obsEnd = new IntersectionObserver(function (entries) {
      atReviews = entries[0].isIntersecting;
      render();
    }, { threshold: 0 });
    obsEnd.observe(endEl);
  }

  function init() {
    realBtn = findReal();
    if (!realBtn) return;
    buildBar();
    mirror();
    watchReal();
    bindEnd();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (MQ.addEventListener) MQ.addEventListener('change', measure);
    else if (MQ.addListener) MQ.addListener(measure);

    measure();
    /* Judge.me and images shift the layout after load - re-measure once. */
    window.addEventListener('load', function () { setTimeout(measure, 300); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
